import React from "react";

/**
 * Delegate a click to a single <a> inside the clicked element.
 * Preserves modifier keys (ctrl/meta/shift) for new-tab behavior.
 */
export const delegateClickToLink =
    (ref?: React.RefObject<HTMLAnchorElement | null>) =>
    (event: React.MouseEvent) => {
        // Don't hijack clicks when user is selecting text
        if (window.getSelection()?.toString()) return;
        // Don't hijack clicks on cards with video
        if (event.currentTarget.querySelector("video")) return;

        let link: HTMLAnchorElement;

        // aria-hidden thing created with TwoUpCard's measure ref in mind, but
        // should be a reasonably generic thing to add
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const links = event.currentTarget.querySelectorAll(
            "a:not([aria-hidden] a)",
        ) as NodeListOf<HTMLAnchorElement>;
        if (ref?.current) link = ref.current;
        else if (links.length === 1) link = links[0];
        else return;

        // Don't re-dispatch if the click originated from the target link
        if (link.contains(event.target as Node)) return;

        link.dispatchEvent(
            new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey,
            }),
        );
    };
